import { render, staticRenderFns } from "./comment-poster.vue?vue&type=template&id=266ced41&scoped=true&"
import script from "./comment-poster.vue?vue&type=script&lang=js&"
export * from "./comment-poster.vue?vue&type=script&lang=js&"
import style0 from "./comment-poster.vue?vue&type=style&index=0&id=266ced41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ced41",
  null
  
)

export default component.exports